import { Check } from 'lucide-react';
import { useEffect } from 'react';
import { LANGS, useLang, useT } from '../lib/i18n';
import { useSoundbox, type VoiceLang } from '../lib/soundbox';
import { Sheet } from './ui';
import { useUi } from './ui-store';

/** Change language: the app's words, and the soundbox voice along with them. */
export function LanguageSheet() {
  const { language, set } = useUi();
  const { lang, setLang } = useLang();
  const t = useT();
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  return (
    <Sheet open={language} onClose={() => set({ language: false })} title={t('Change language')}>
      <div role="radiogroup" aria-label={t('Language')} className="flex flex-col gap-2 pb-2">
        {LANGS.map((l) => (
          <button key={l.id} role="radio" aria-checked={lang === l.id}
            onClick={() => { setLang(l.id); useSoundbox.getState().set({ lang: l.speech as VoiceLang }); set({ language: false }); }}
            className={`flex h-16 items-center gap-3 rounded-2xl border px-4 text-left ${lang === l.id ? 'border-forest-700 bg-forest-50' : 'border-line bg-white'}`}>
            <span className="min-w-0 flex-1"><span className="block text-base font-semibold">{l.native}</span>{l.native !== l.name && <span className="block text-xs text-ink-3">{l.name}</span>}</span>
            {lang === l.id && <Check size={20} className="text-primary" />}
          </button>
        ))}
      </div>
    </Sheet>
  );
}
